import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Alert, Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';

import { FormProvider, RHFTextField } from '../../../components/hook-form';
import { postNumberSwapBindings } from '../../../services/simSwap';
import { ICCID_REGEX, MSISDN_REGEX } from './validation';

const schema = yup.object().shape({
  msisdn: yup
    .string()
    .trim()
    .required('MSISDN is required')
    .matches(MSISDN_REGEX, 'MSISDN must be exactly 9 digits'),
  iccid: yup
    .string()
    .trim()
    .required('ICCID is required')
    .matches(ICCID_REGEX, 'ICCID must be exactly 20 digits'),
});

export default function SingleSwapForm() {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { msisdn: '', iccid: '' },
  });
  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  const [result, setResult] = useState(null);

  const onSubmit = async (values) => {
    setResult(null);
    try {
      const response = await postNumberSwapBindings([{ msisdn: values.msisdn, iccid: values.iccid }]);
      setResult({ ok: true, payload: response.data });
      reset();
    } catch (err) {
      const message = err?.response?.data?.message || err?.message || 'Request failed';
      setResult({ ok: false, payload: message });
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Execute SIM Swap
        </Typography>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}>
            <RHFTextField name="msisdn" label="MSISDN" placeholder="e.g. 554650302" />
            <RHFTextField name="iccid" label="ICCID" placeholder="e.g. 89994550070219764946" />
            <Box>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                {isSubmitting ? 'Executing…' : 'Execute swap'}
              </Button>
            </Box>
            {result && (
              <Alert severity={result.ok ? 'success' : 'error'}>
                {result.ok
                  ? 'SIM swap request submitted successfully.'
                  : `Failed: ${typeof result.payload === 'string' ? result.payload : JSON.stringify(result.payload)}`}
              </Alert>
            )}
          </Stack>
        </FormProvider>
      </CardContent>
    </Card>
  );
}
